module.exports = __webpack_public_path__ + "media/images/emblems/CHE_Villaz_FR_COA-3eb7299039a6916d63be0ee1745fe242.svg";